
const primary = '#Ad974F';
const secondary = '#25282a';

export {primary, secondary}